import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import SvgIcon from "@mui/material/SvgIcon";
import classnames from "classnames";
import { useStyles } from "./Reactions.styles.js";
const HeartEyes = (t0)=>{
    const $ = c(23);
    const { size: t1, color: t2 } = t0;
    const size = void 0 === t1 ? "default" : t1;
    const color = void 0 === t2 ? "secondary" : t2;
    const { classes } = useStyles();
    const t3 = classes[`icon_size_${size}`];
    const t4 = classes[`icon_color_${color}`];
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = classnames(t3, t4);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    let t6;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsxs("g", {
            clipPath: "url(#clip0_4706_230067)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M9.97558 17.0527C13.8588 17.0527 17.0068 13.9047 17.0068 10.0215C17.0068 6.13823 13.8588 2.99023 9.97558 2.99023C6.09233 2.99023 2.94434 6.13823 2.94434 10.0215C2.94434 13.9047 6.09233 17.0527 9.97558 17.0527Z",
                    fill: "url(#paint0_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M9.97558 17.0527C13.8588 17.0527 17.0068 13.9047 17.0068 10.0215C17.0068 6.13823 13.8588 2.99023 9.97558 2.99023C6.09233 2.99023 2.94434 6.13823 2.94434 10.0215C2.94434 13.9047 6.09233 17.0527 9.97558 17.0527Z",
                    fill: "url(#paint1_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M9.97949 17.0332C13.8627 17.0332 17.0107 13.8852 17.0107 10.002C17.0107 6.1187 13.8627 2.9707 9.97949 2.9707C6.09624 2.9707 2.94824 6.1187 2.94824 10.002C2.94824 13.8852 6.09624 17.0332 9.97949 17.0332Z",
                    fill: "url(#paint2_radial_4706_230067)",
                    fillOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M9.97949 2.9707C6.09624 2.9707 2.94824 6.1187 2.94824 10.002C2.94824 13.8852 6.09624 17.0332 9.97949 17.0332C13.8627 17.0332 17.0107 13.8852 17.0107 10.002C17.0107 6.1187 13.8627 2.9707 9.97949 2.9707Z",
                    fill: "url(#paint3_radial_4706_230067)",
                    fillOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M5.79193 9.97409C5.66822 9.90729 5.51524 9.9754 5.51962 10.1159C5.5574 11.3266 6.76003 14.0662 9.97599 14.0662C13.258 14.0662 14.5078 11.5832 14.4508 10.2324C14.4452 10.0987 14.2999 10.0308 14.1785 10.0872C12.3056 10.9579 7.72625 11.0184 5.79193 9.97409Z",
                    fill: "#3F1C30"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M5.48671 9.72208C5.62201 9.65528 5.7847 9.65944 5.92184 9.73348C6.82797 10.2227 8.40041 10.4688 10.0094 10.4753C11.6163 10.4819 13.1814 10.2492 14.0632 9.83928C14.1997 9.77586 14.3547 9.77984 14.4823 9.84496C14.6144 9.91234 14.7167 10.0468 14.724 10.2209C14.7869 11.7121 13.4281 14.3396 9.97599 14.3396C8.27998 14.3396 7.10145 13.6133 6.34723 12.7217C5.60219 11.8409 5.26724 10.7948 5.24632 10.1245C5.24056 9.93974 5.34424 9.79241 5.48671 9.72208ZM5.51963 10.1159C5.51524 9.97541 5.66823 9.9073 5.79194 9.97409C7.72625 11.0184 12.3056 10.9579 14.1785 10.0872C14.2999 10.0308 14.4452 10.0987 14.4508 10.2324C14.5078 11.5832 13.258 14.0662 9.97599 14.0662C6.76004 14.0662 5.5574 11.3266 5.51963 10.1159Z",
                    fill: "url(#paint4_linear_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M12.1444 13.6222C11.9454 13.1125 11.0543 12.7285 9.98535 12.7285C8.94263 12.7285 8.07736 13.0906 7.8457 13.5778C8.40288 13.865 9.07302 14.0499 9.86957 14.065C9.908 14.0656 9.94669 14.0659 9.98565 14.066C10.8385 14.0647 11.5538 13.8955 12.1444 13.6222Z",
                    fill: "url(#paint5_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M14.0389 10.1572C14.0389 10.6808 13.6202 11.9011 9.99873 11.9011C6.37688 11.9011 5.95898 10.5712 5.95898 10.1572C5.95898 10.1236 5.95984 10.0911 5.96154 10.0596C7.93193 10.9907 12.1432 10.9367 14.0389 10.1486C14.0389 10.1515 14.0389 10.1543 14.0389 10.1572Z",
                    fill: "white"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M14.0389 10.1572C14.0389 10.6808 11.8324 11.0164 9.99873 11.0164C8.16509 11.0164 5.95898 10.5712 5.95898 10.1572C5.95898 10.1236 5.95984 10.0911 5.96154 10.0596C7.93193 10.9907 12.1432 10.9367 14.0389 10.1486C14.0389 10.1515 14.0389 10.1543 14.0389 10.1572Z",
                    fill: "url(#paint6_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M8.31259 4.29819C7.55332 3.88313 6.49946 4.32257 6.15705 5.12119C5.53382 4.62714 4.29544 4.76907 3.87881 5.48621C3.54186 6.06616 3.31636 7.19802 4.53455 8.22654C5.54409 9.02627 6.89933 9.57677 7.32067 9.46387C7.74202 9.35097 8.64044 8.19661 9.11486 6.99924C9.65558 5.49943 8.90113 4.61985 8.31259 4.29819Z",
                    fill: "url(#paint7_linear_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M8.31259 4.29819C7.55332 3.88313 6.49946 4.32257 6.15705 5.12119C5.53382 4.62714 4.29544 4.76907 3.87881 5.48621C3.54186 6.06616 3.31636 7.19802 4.53455 8.22654C5.54409 9.02627 6.89933 9.57677 7.32067 9.46387C7.74202 9.35097 8.64044 8.19661 9.11486 6.99924C9.65558 5.49943 8.90113 4.61985 8.31259 4.29819Z",
                    fill: "url(#paint8_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M8.31259 4.29819C7.55332 3.88313 6.49946 4.32257 6.15705 5.12119C5.53382 4.62714 4.29544 4.76907 3.87881 5.48621C3.54186 6.06616 3.31636 7.19802 4.53455 8.22654C5.54409 9.02627 6.89933 9.57677 7.32067 9.46387C7.74202 9.35097 8.64044 8.19661 9.11486 6.99924C9.65558 5.49943 8.90113 4.61985 8.31259 4.29819Z",
                    fill: "url(#paint9_radial_4706_230067)",
                    fillOpacity: "0.7"
                }),
                /*#__PURE__*/ jsx("path", {
                    opacity: "0.6",
                    d: "M5.34056 7.53135C6.03998 7.34395 6.45504 6.62504 6.26763 5.92563C6.08022 5.22622 5.36132 4.81115 4.6619 4.99856C3.96249 5.18597 3.54743 5.90488 3.73484 6.60429C3.92224 7.3037 4.64115 7.71876 5.34056 7.53135Z",
                    fill: "url(#paint10_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    opacity: "0.9",
                    d: "M7.6417 6.31685C8.12387 6.18766 8.41001 5.69204 8.28081 5.20987C8.15162 4.7277 7.656 4.44156 7.17383 4.57075C6.69166 4.69995 6.40552 5.19557 6.53471 5.67774C6.66391 6.15991 7.15952 6.44605 7.6417 6.31685Z",
                    fill: "url(#paint11_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M11.6796 4.29819C12.4389 3.88313 13.4927 4.32257 13.8351 5.12119C14.4584 4.62714 15.6967 4.76907 16.1134 5.48621C16.4503 6.06616 16.6758 7.19802 15.4576 8.22654C14.4481 9.02627 13.0929 9.57677 12.6715 9.46387C12.2502 9.35097 11.3517 8.19661 10.8773 6.99924C10.3366 5.49943 11.0911 4.61985 11.6796 4.29819Z",
                    fill: "url(#paint12_linear_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M11.6796 4.29819C12.4389 3.88313 13.4927 4.32257 13.8351 5.12119C14.4584 4.62714 15.6967 4.76907 16.1134 5.48621C16.4503 6.06616 16.6758 7.19802 15.4576 8.22653C14.4481 9.02627 13.0929 9.57677 12.6715 9.46387C12.2502 9.35097 11.3517 8.19661 10.8773 6.99924C10.3366 5.49943 11.0911 4.61985 11.6796 4.29819Z",
                    fill: "url(#paint13_radial_4706_230067)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M11.6796 4.29819C12.4389 3.88313 13.4927 4.32257 13.8351 5.12119C14.4584 4.62714 15.6967 4.76907 16.1134 5.48621C16.4503 6.06616 16.6758 7.19802 15.4576 8.22653C14.4481 9.02627 13.0929 9.57677 12.6715 9.46387C12.2502 9.35097 11.3517 8.19661 10.8773 6.99924C10.3366 5.49943 11.0911 4.61985 11.6796 4.29819Z",
                    fill: "url(#paint14_radial_4706_230067)",
                    fillOpacity: "0.7"
                }),
                /*#__PURE__*/ jsx("path", {
                    opacity: "0.9",
                    d: "M12.283 6.56835C11.6621 6.40198 11.2937 5.76377 11.46 5.14286C11.6264 4.52195 12.2646 4.15348 12.8855 4.31985C13.5064 4.48622 13.8749 5.12444 13.7085 5.74534C13.5422 6.36625 12.9039 6.73472 12.283 6.56835Z",
                    fill: "url(#paint15_radial_4706_230067)"
                })
            ]
        });
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.76937 3.83147) scale(13.1441 13.1441)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.43",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00"
                })
            ]
        });
        $[4] = t7;
    } else t7 = $[4];
    let t8;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.79164 4.09604) rotate(54.7041) scale(13.945 13.929)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.608798",
                    stopColor: "#FFE437",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.858784",
                    stopColor: "#FF79B1",
                    stopOpacity: "0.45"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#FF3673",
                    stopOpacity: "0.56"
                })
            ]
        });
        $[5] = t8;
    } else t8 = $[5];
    let t9;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.97949 10.3221) rotate(-90) scale(7.73511 7.38974)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.848958",
                    stopColor: "#FFC60C",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF7039",
                    stopOpacity: "0.68"
                })
            ]
        });
        $[6] = t9;
    } else t9 = $[6];
    let t10;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.97949 9.68178) rotate(90) scale(7.35142 7.28983)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.847356",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint4_linear_4706_230067",
            x1: "9.9861",
            y1: "9.94825",
            x2: "9.9861",
            y2: "14.0662",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FD9E28",
                    stopOpacity: "0.4"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFF2B7"
                })
            ]
        });
        $[8] = t11;
    } else t11 = $[8];
    let t12;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(9.99507 12.7285) rotate(90.0008) scale(1.46321 3.19357)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF7294"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.416498",
                    stopColor: "#FF71A4"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#EF164A"
                })
            ]
        });
        $[9] = t12;
    } else t12 = $[9];
    let t13;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(10.1197 10.6811) rotate(178.995) scale(4.52705 29.7107)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#C9C9C9"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D2D2D2",
                    stopOpacity: "0.6"
                })
            ]
        });
        $[10] = t13;
    } else t13 = $[10];
    let t14;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint7_linear_4706_230067",
            x1: "4.91929",
            y1: "5.23324",
            x2: "7.67937",
            y2: "9.36077",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF4F37"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.42",
                    stopColor: "#EA002D"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D30D81"
                })
            ]
        });
        $[11] = t14;
    } else t14 = $[11];
    let t15;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint8_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.61002 4.3186) rotate(131.362) scale(5.2432 5.2432)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.66",
                    stopColor: "#E20A26",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#C40000"
                })
            ]
        });
        $[12] = t15;
    } else t15 = $[12];
    let t16;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint9_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(5.26808 6.19578) rotate(33.0239) scale(3.99797 5.73883)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.395833",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.826596",
                    stopColor: "#C933CC",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F459AD"
                })
            ]
        });
        $[13] = t16;
    } else t16 = $[13];
    let t17;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint10_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(5.00801 6.23508) rotate(-15) scale(1.31915)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF0027",
                    stopOpacity: "0"
                })
            ]
        });
        $[14] = t17;
    } else t17 = $[14];
    let t18;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint11_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(7.45137 5.44108) rotate(-15) scale(0.891735)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF1F1F",
                    stopOpacity: "0"
                })
            ]
        });
        $[15] = t18;
    } else t18 = $[15];
    let t19;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint12_linear_4706_230067",
            x1: "15.0729",
            y1: "5.23324",
            x2: "12.2239",
            y2: "9.38942",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF4F37"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.42",
                    stopColor: "#EA002D"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#D30D81"
                })
            ]
        });
        $[16] = t19;
    } else t19 = $[16];
    let t20;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint13_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(13.3308 4.97514) rotate(54.0757) scale(4.19181)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.66",
                    stopColor: "#E20A26",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#C40000"
                })
            ]
        });
        $[17] = t20;
    } else t20 = $[17];
    let t21;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint14_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.0572 5.0052) rotate(63.8589) scale(4.61131 6.61924)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.395833",
                    stopColor: "#FF4570",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.796239",
                    stopColor: "#C933CC",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F459AD"
                })
            ]
        });
        $[18] = t21;
    } else t21 = $[18];
    let t22;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint15_radial_4706_230067",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(12.5281 5.44059) rotate(-165) scale(1.14831)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF9999",
                    stopOpacity: "0.6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF1F1F",
                    stopOpacity: "0"
                })
            ]
        });
        $[19] = t22;
    } else t22 = $[19];
    let t23;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_4706_230067",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            ]
        });
        $[20] = t23;
    } else t23 = $[20];
    let t24;
    if ($[21] !== t5) {
        t24 = /*#__PURE__*/ jsxs(SvgIcon, {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: t5,
            children: [
                t6,
                t23
            ]
        });
        $[21] = t5;
        $[22] = t24;
    } else t24 = $[22];
    return t24;
};
export { HeartEyes };
